// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SET_META = 'meta/SET_META';
export const SET_LICENSE_IS_ACTIVE = 'meta/SET_LICENSE_IS_ACTIVE';
